import pre from './pre.js';
import post from './post.js';
import cart from './cart.vue';
import config from './config/index.vue';
import success from './success.vue';
import addon from './addon.vue';

export default {
    pre,
    components: {
        config,
        cart,
        addon,
        success,
    },
    post,
}
